"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const common_buoy_user_feedback_1 = require("@buoyhealth/common.buoy-user-feedback");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const react_waypoint_1 = require("react-waypoint");
const analytics_1 = require("./analytics");
const Checkout_1 = __importDefault(require("./components/Checkout"));
const CloseIcon_1 = __importDefault(require("./components/CloseIcon"));
const styles_1 = require("./styles");
const Tipping = ({ stripeApiKey, customConfig, interviewToken, onClose, onTippingSuccess, variant, }) => {
    const [tip, setTip] = (0, react_1.useState)();
    const [customTip, setCustomTip] = (0, react_1.useState)();
    const [showError, setShowError] = (0, react_1.useState)(false);
    const [showCheckout, setShowCheckout] = (0, react_1.useState)(false);
    const [isSuccessful, setIsSuccessful] = (0, react_1.useState)();
    const tipAmount = customTip || tip;
    const isCardVariant = variant === "card";
    // For snowlow analytics purposes
    const tippingPlacement = isCardVariant ? "eoi-block" : "popup";
    const config = (0, react_1.useMemo)(() => {
        const configuration = customConfig || {};
        return {
            ...common_buoy_user_feedback_1.DEFAULT_TIPPING_CONFIG,
            ...configuration,
            ...(isSuccessful
                ? {
                    title: "Thanks for tipping. ",
                    description: `Your $${tipAmount} tip has been sent. We appreciate your generous support.`,
                }
                : {}),
        };
    }, [customConfig, isSuccessful, tipAmount]);
    const handleSubmit = (0, react_1.useCallback)(async () => {
        if (tipAmount) {
            (0, analytics_1.trackSubmitClick)(interviewToken || "", tipAmount, tippingPlacement);
            setShowCheckout(true);
        }
        else {
            setShowError(true);
        }
    }, [interviewToken, tipAmount]);
    const handleButtonClick = (_e, value) => {
        setShowError(false);
        setCustomTip(undefined);
        if (value === tip) {
            setTip(undefined);
        }
        else {
            (0, analytics_1.trackPresetAmountClick)(interviewToken || "", value, tippingPlacement);
            setTip(value);
        }
    };
    const handleCustomInput = (e) => {
        setTip(undefined);
        setShowError(false);
        const { value } = e.target;
        const formattedValue = parseFloat(Number(value.replace("$", "")).toFixed(2));
        (0, analytics_1.trackCustomAmountChangeEvent)(interviewToken || "", formattedValue, tippingPlacement);
        setCustomTip(value && !isNaN(formattedValue) ? formattedValue : undefined);
    };
    const onCheckoutClose = (status) => {
        setShowCheckout(false);
        if (status === "succeeded") {
            setIsSuccessful(true);
            onTippingSuccess?.();
        }
    };
    const onCustomAmountClick = () => {
        setTip(undefined);
        (0, analytics_1.trackCustomAmountClick)(interviewToken || "", tippingPlacement);
    };
    const shouldShowTitle = isCardVariant || (!isCardVariant && isSuccessful);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isCardVariant && (0, jsx_runtime_1.jsx)(styles_1.MobileDivider, {}), (0, jsx_runtime_1.jsx)(common_buoy_theme_1.Provider, { children: (0, jsx_runtime_1.jsxs)(styles_1.Container, { bgColor: config.background_color, isCard: isCardVariant, children: [shouldShowTitle && ((0, jsx_runtime_1.jsxs)(styles_1.TitleContainer, { isDialog: !isCardVariant, children: [(0, jsx_runtime_1.jsxs)(styles_1.Title, { large: !isCardVariant && isSuccessful, children: [config.title, isSuccessful && (0, jsx_runtime_1.jsx)(styles_1.AnimatedTada, { children: "\uD83C\uDF89" })] }), !isCardVariant && (0, jsx_runtime_1.jsx)(CloseIcon_1.default, { onClose: onClose })] })), (0, jsx_runtime_1.jsx)(styles_1.Paragraph, { isCard: isCardVariant, children: config.description }), !isSuccessful && ((0, jsx_runtime_1.jsx)(react_waypoint_1.Waypoint, { onEnter: () => (0, analytics_1.trackTippingModuleViewed)(interviewToken || "", tippingPlacement), children: (0, jsx_runtime_1.jsxs)(styles_1.ButtonContainer, { isDialog: !isCardVariant, children: [(0, jsx_runtime_1.jsxs)(styles_1.TippingButtons, { children: [config.default_tip_values.map((amount) => ((0, jsx_runtime_1.jsxs)(styles_1.StyledToggleButton, { onChange: handleButtonClick, value: amount, selected: amount === tip, color: showError ? "error" : "primary", children: ["$", amount] }, amount))), (0, jsx_runtime_1.jsx)(styles_1.StyledTextInput, { placeholder: "Other", onChange: handleCustomInput, onFocus: onCustomAmountClick, inputMode: "numeric", value: customTip ? `$${customTip}` : "", error: showError })] }), (0, jsx_runtime_1.jsx)(common_buoy_button_1.CTAButton, { onClick: handleSubmit, type: "submit", fullWidth: true, children: config.button_text })] }) })), (0, jsx_runtime_1.jsx)(common_buoy_input_1.ErrorText, { show: showError, message: "Please select a tip amount" })] }) }), showCheckout && tipAmount && ((0, jsx_runtime_1.jsx)(Checkout_1.default, { onClose: onCheckoutClose, tipAmount: tipAmount, interviewToken: interviewToken, stripeApiKey: stripeApiKey, tippingPlacement: tippingPlacement }))] }));
};
exports.default = Tipping;
//# sourceMappingURL=index.js.map